<template>
  <div id="creditManagement">
    <div class="box news-box">
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/creditManagementIndex' }">信用管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="new-wrapper">
        <div class="left-box fl" style="    padding-bottom: 25px;">
          <div class="left-box-title">
            <img src="../../assets/images/notice-icon.png" style="top: 14px" alt />
            失信黑名单
            <img src="../../assets/images/right.png" alt />
          </div>
          <div class="left-box-content">
            <img style="    width: 100%;" src="../../assets/xygl.png" alt />
          </div>
        </div>
        <div
          class="right-box fr"
          style="    padding: 40px 0;
    padding-right: 60px;
    box-sizing: border-box;"
        >
          <el-form :model="creditForm" ref="creditForm" label-width="100px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="信用代码：" prop="creditCode">
                  <el-input disabled v-model="creditForm.creditCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="法人名称：" prop="legalPersonName">
                  <el-input disabled v-model="creditForm.legalPersonName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="单位名称：" prop="unitName">
                  <el-input disabled v-model="creditForm.unitName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="经营场所：" prop="operatePlace">
                  <el-input disabled v-model="creditForm.operatePlace"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="单位类型：" prop="unitType">
                  <el-select v-model="creditForm.unitType" placeholder="请选择" disabled style="width:100%">
                    <el-option
                      v-for="item in unitTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="成立时间：" prop="setUpTime">
                  <el-date-picker
                    disabled
                    style="width:100%"
                    v-model="creditForm.setUpTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import { getCreditDataById } from "../../api/index.js";
export default {
  data() {
    return {
        unitTypeOptions:[{
            value: '1',
            label: '国有企业'
        }, {
            value: '2',
            label: '国有控股企业'
        }, {
            value: '3',
            label: '外资企业'
        }, {
            value: '4',
            label: '合资企业'
        }, {
            value: '5',
            label: '私营企业'
        }, {
            value: '6',
            label: '事业单位'
        }, {
            value: '7',
            label: '国家行政机关'
        }, {
            value: '8',
            label: '政府'
        }
      ],
      creditForm: {
        id: null,
        creditCode: null,
        legalPersonName: null,
        setUpTime: null,
        unitType: null,
        unitName: null,
        operatePlace: null
      }
    };
  },
  created() {
    this.creditForm.id = this.$route.params.id;
    if (this.creditForm.id) {
      this.getOne();
    }
  },
  methods: {
    getOne() {
      getCreditDataById({
        id: this.creditForm.id
      }).then(res => {
        if (res.flag) {
          this.creditForm = res.data;
        }
      });
    }
  }
};
</script>

<style lang="" >
#creditManagement .el-table th {
  background: rgba(1, 173, 214, 1);
  color: #fff;
}
#creditManagement .el-table--enable-row-transition .el-table__body td {
  border: 1px solid #fff;
}
.el-breadcrumb__inner.is-link,
.el-breadcrumb__item {
  cursor: pointer !important;
}
#creditManagement .el-input__inner{
  border: none !important;
}
.el-input.is-disabled .el-input__inner{
  background: #fff;
  color: #606266;
}
.el-input.is-disabled .el-input__icon{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/creditManagement/detail.vue